import { buildRoutingGraphFromMcBimPipeGeometries, } from "../routing/pipeMcBimGeometryToRoutingGraph.logic";
import { copyPipesFromASpaceToAnotherSpace, } from "./copyPipesFromASpaceToAnotherSpace";
export const buildAndCopyPipesFromMcBimSpace = (args) => {
    const { spaceToCopyFrom, spaceToCopyTo, ...buildRoutingGraphArgs } = args;
    const routingGraph = buildRoutingGraphFromMcBimPipeGeometries(buildRoutingGraphArgs);
    return copyPipesFromASpaceToAnotherSpace({
        routingGraphsToCopy: [routingGraph],
        spaceToCopyFrom,
        spaceToCopyTo,
    });
};
